import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

/**
 * Submenu trigger item that opens on hover or click
 */
export default function SubmenuMenuItem({
                                            label,
                                            open,
                                            onMouseEnter,
                                            onClick,
                                        }) {
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        } else {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    const handleMouseDown = (e) => {
        if (!onClick) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    return (
        <MenuItem
            onMouseEnter={onMouseEnter}
            onClick={handleClick}
            onMouseDown={handleMouseDown}
            aria-haspopup="menu"
            aria-expanded={open ? 'true' : undefined}
            style={{display: 'flex', alignItems: 'center'}}
        >
            <span style={{flex: 1}}>{label}</span>
            <KeyboardArrowRightIcon fontSize="small"/>
        </MenuItem>
    );
}
